module.exports = __webpack_public_path__ + "img/boundary-hide-hover.8e61cc53.svg";